import { ModuleLayout } from '@billy/design-system'
import { ReactElement } from 'react'
import { useTranslation } from 'react-i18next'
import { Navigate, useParams } from 'react-router'

import { useUserOrganization } from '@modules-deprecated/app/organization'
import { FileListSkeleton } from '@views/documents/elements/FileList'

import { getOrganizationViewUrl } from '../../../../utils/routing/getOrganizationViewUrl'
import { reactRoute } from '../../../../utils/routing/reactRoute'
import { useDmsUserRole } from '../../hooks/useDmsUserRole'
import { useFetchDocumentById } from '../../hooks/useFetchDocumentById'
import { setPendingOpenDocumentId } from '../../utils/pendingOpenDocument'
import { DocumentLinkErrorState } from './elements/DocumentLinkErrorState'

export type DocumentParams = {
  documentId?: string
}

export const DocumentLink = (): ReactElement => {
  const { t } = useTranslation()
  const { organization } = useUserOrganization()
  const { documentId } = useParams<DocumentParams>()
  const { document, isError, isLoading } = useFetchDocumentById(documentId)
  const { isBoWithCpa, isCpaClientMode, isCpaExpertMode, isLoading: isRoleLoading } = useDmsUserRole()

  if (isLoading || isRoleLoading) {
    return (
      <ModuleLayout fullWidth title={t('navigation.menu.label.documents')} withMenuOffset={false}>
        <FileListSkeleton />
      </ModuleLayout>
    )
  }

  if (isError || !document) {
    return <DocumentLinkErrorState />
  }

  const getTargetRoute = () => {
    if (document.folderId) {
      return isCpaExpertMode
        ? reactRoute.organization.documents.getFolderRoute(document.folderId)
        : reactRoute.organization.clientDocuments.getFolderRoute(document.folderId)
    }
    if (isCpaExpertMode) {
      return reactRoute.organization.documents.getUnsortedRoute()
    }
    if (isBoWithCpa || isCpaClientMode) {
      return reactRoute.organization.clientDocuments.getSharedByMeRoute()
    }
    return reactRoute.organization.documents.getMainRoute()
  }

  setPendingOpenDocumentId(document.id)

  const targetUrl = getOrganizationViewUrl(organization?.url, getTargetRoute())

  return <Navigate replace to={targetUrl} />
}
